import { jsx } from "react/jsx-runtime";
import React from "react";
var image_strikethrough_default = (prefix = "") => {
  return [/* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m2.3979 2.414 19.1846 19.1907-1.3978 1.3965-3.0002-3.0011H3V5.8113L1 3.8106l1.3979-1.3965zM15.185 18.0002l-1.9994-2H6.5l2.6748-4.0122L5 7.8119V18h10.1851z" }), /* @__PURE__ */ jsx("path", { d: "m6.8114 4.0001 1.9994 2H19v10.1924l2 2.0006V4.0001H6.8114z" }), /* @__PURE__ */ jsx("path", { d: "M14 9.5001c0 .8284.6716 1.5 1.5 1.5s1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5z" })];
};
export {
  image_strikethrough_default as default
};
